export const boundary = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.129141, -37.440034],
        [175.128647, -37.439693],
        [175.131081, -37.43671],
        [175.132826, -37.438074],
        [175.133153, -37.438432],
        [175.136828, -37.441188],
        [175.133062, -37.444378],
        [175.130503, -37.442853],
        [175.128433, -37.440826],
        [175.129141, -37.440034],
      ],
    ],
  },
};

export const noiseBoundary = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.131249, -37.437806],
        [175.132308, -37.438592],
        [175.132544, -37.438888],
        [175.135669, -37.441226],
        [175.132957, -37.443475],
        [175.131077, -37.442359],
        [175.129302, -37.440802],
        [175.130289, -37.439838],
        [175.129819, -37.439527],
        [175.131249, -37.437806],
      ],
    ],
  },
};

export const dualMeasurementZoneOne = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.130109, -37.438118],
        [175.130956, -37.437093],
        [175.131455, -37.437093],
        [175.131766, -37.437411],
        [175.131056, -37.438122],
        [175.130109, -37.438118],
      ],
    ],
  },
};

export const dualMeasurementZoneTwo = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.130232, -37.438978],
        [175.130039, -37.438224],
        [175.130568, -37.43822],
        [175.130841, -37.438329],
        [175.130836, -37.438431],
        [175.130594, -37.438696],
        [175.130541, -37.438972],
        [175.130232, -37.438978],
      ],
    ],
  },
};

export const dualMeasurementZoneThree = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.13012, -37.438886],
        [175.130109, -37.439633],
        [175.129908, -37.439646],
        [175.1299, -37.439821],
        [175.129677, -37.43984],
        [175.129543, -37.439963],
        [175.129538, -37.440108],
        [175.129186, -37.440105],
        [175.128658, -37.439739],
        [175.129436, -37.438884],
        [175.13012, -37.438886],
      ],
    ],
  },
};

export const dualMeasurementZoneFour = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [175.13646, -37.441193],
        [175.136452, -37.440963],
        [175.135892, -37.440575],
        [175.135645, -37.440577],
        [175.135414, -37.440698],
        [175.135865, -37.441077],
        [175.135712, -37.441209],
        [175.135548, -37.441495],
        [175.135556, -37.441656],
        [175.135956, -37.441661],
        [175.13646, -37.441193],
      ],
    ],
  },
};
